import React, { useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import BrandSegmented from "../../CoreComponents/BrandSegmented";
import { showMessage } from "../../Functionalities/Functions";
import LinkExisting from "./LinkExisting";
import MergeDialog from "./MergeDialog";
import RenameDialog from "./RenameDialog";
import UmbrellaTable from "./UmbrellaTable";
import { mergeUmbrella, updateUmbrella } from "./umbrellaData";
import useUmbrellaList from "./useUmbrellaList";
import "./categoryUmbrellas.css";

const TABS = ["All", "Review"];

function Body() {
  const list = useUmbrellaList();
  const [draft, setDraft] = useState("");
  const [renaming, setRenaming] = useState(null);
  const [merging, setMerging] = useState(null);

  const done = (reply, closeDialog) => {
    if (reply.error) {
      showMessage(reply.error, "danger", "Failed!", "top", "top-right", 0);
      return;
    }
    closeDialog();
    list.reload();
  };

  return (
    <div className="content-body">
      <div className="container-fluid umb">
        <LinkExisting onApplied={list.reload} />
        <section className="umb-card">
          <div className="umb-toolbar">
            <BrandSegmented options={TABS} value={list.query.review ? "Review" : "All"} onChange={(tab) => list.showTab(tab === "Review")} />
            <form className="umb-search" onSubmit={(event) => { event.preventDefault(); list.search(draft.trim()); }}>
              <input className="form-control" aria-label="Search categories" value={draft} onChange={(event) => setDraft(event.target.value)} />
              <button type="submit" className="btn btn-primary">Search</button>
            </form>
          </div>
          <UmbrellaTable
            data={list.data}
            page={list.query.page}
            loading={list.loading}
            onPage={list.showPage}
            onHide={async (row, hide) => done(await updateUmbrella(row.id, { hide_from_home: hide }), () => {})}
            onRename={setRenaming}
            onMerge={setMerging}
          />
        </section>
        {renaming && (
          <RenameDialog
            umbrella={renaming}
            onClose={() => setRenaming(null)}
            onSave={async (name) => done(await updateUmbrella(renaming.id, { name }), () => setRenaming(null))}
          />
        )}
        {merging && (
          <MergeDialog
            umbrella={merging}
            others={list.data.results.filter((row) => row.id !== merging.id)}
            onClose={() => setMerging(null)}
            onMerge={async (intoId) => done(await mergeUmbrella(merging.id, intoId), () => setMerging(null))}
          />
        )}
      </div>
    </div>
  );
}

export default function CategoryUmbrellas() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name="Category umbrellas" />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}
